import { GetStaticProps, GetStaticPaths } from 'next';
import { getLanguagesPaths } from '~/utils/translate';
import { NextSeo } from 'next-seo';
import Section from '~/components/business/inner-pages/section';
import { useTranslate } from '~/i18n';
// import BusinessForm from '~/components/business/inner-pages/business-form';
import TopSection from '~/components/business/inner-pages/top-section';
import Header from '~/components/business/inner-pages/header';
const EventManagement = () => {
   const { translate } = useTranslate();

   return (
      <div>
         <NextSeo title={translate({ id: 'innerbusiness:heading' })} />
         <Header
            backgroundColor="event-management-bg"
            smallBackgroundIamge="/images/business/manage-your-event.png"
            title={translate({ id: 'innerbusiness:heading' })}
            backgroundImage="/images/business/inner/1.jpg"
            backgroundImageAr="/images/business/inner/1-ar.jpg"
            breadCrumbcolor="text-primary-color"
            lastBreadCrumb="نظم فعاليات"
         />
         <TopSection
            firstpargraph={translate({ id: 'innerbusiness:event management company' })}
            secondpargraph={translate({ id: 'innerbusiness:reach customers' })}
            thirdpargraph={translate({ id: 'innerbusiness:real-time seat bookings' })}
            fourthpargraph={translate({ id: 'innerbusiness:custom built app' })}
            // button={translate({ id: 'innerbusiness:get event and ticketing solutions' })}
            img="/images/business/inner/hybp-dashboard.jpg"
         />
         <Section
            title={translate({ id: 'innerbusiness:event management platform' })}
            content={translate({ id: 'innerbusiness:jeddah season festival' })}
            image="/images/business/inner/events.png"
            leading={true}
         />
         <Section
            title={translate({ id: 'innerbusiness:brandable vehicles' })}
            content={translate({ id: 'innerbusiness:broaden your customer reach' })}
            innerImage="/images/business/logos/jarir.png"
            image="/images/business/inner/hy-car.png"
            leading={true}
         />
         {/* <BusinessForm /> */}
      </div>
   );
};
export const getStaticPaths: GetStaticPaths = async () => {
   return {
      paths: getLanguagesPaths(),
      fallback: false,
   };
};

/******************************************************************
 *
 *  THIS PAGE IS USING STATIC SITE GENERATION
 *
 ******************************************************************/

export const getStaticProps: GetStaticProps = async () => {
   return {
      props: {},
   };
};
export default EventManagement;
